@if (!config.showLoader) {
    @if (invalidConfig) {
        <div class="invalid-config">
            <span>{{ 'dashboard.kriDetailWidget.noKriSelected' | transloco }}</span>
        </div>
    }
    @if (kriGuid) {
        <kri-data-graph [kriGuid]="kriGuid" [showOpen]="false"></kri-data-graph>
    }
}
